/**
 * Gamepads (spec 08 §3), standard mapping: left stick or d-pad to move, A (0) to jump, B (1) or
 * X (2) to blow, Start (9) to pause. Pad 0 is player 1, pad 1 player 2.
 */

import type { Command } from '../sim/types';

const DEAD = 0.4;

export function padCommand(index: number): Command | null {
  const pad = navigator.getGamepads?.()[index];
  if (!pad) return null;
  const b = (i: number): boolean => pad.buttons[i]?.pressed === true;
  const x = pad.axes[0] ?? 0;
  const y = pad.axes[1] ?? 0;
  return {
    left: x < -DEAD || b(14),
    right: x > DEAD || b(15),
    jump: b(0) || y < -0.7 || b(12),
    fire: b(1) || b(2),
  };
}

export const padPause = (index: number): boolean => navigator.getGamepads?.()[index]?.buttons[9]?.pressed === true;
